import { styled } from '@zeiss/beyond-online-react';
import type { ComponentPropsWithoutRef } from 'react';

type DivProps = ComponentPropsWithoutRef<'div'>;

const StyledModalContainer = styled.div`
  padding: var(--spacing-m);

  @media (width >= 768px) {
    padding: var(--spacing-2xl) var(--spacing-3xl);
  }
`;

const StyledModalContentContainer = styled.div`
  min-height: 14rem;
  margin-bottom: var(--spacing-m);

  @media (width >= 768px) {
    margin-bottom: var(--spacing-xl);
  }
`;

const StyledModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: var(--spacing-s);
  justify-content: flex-end;

  @media (width >= 768px) {
    flex-direction: row;
  }
`;

export const ModalContainer = ({ children, ...props }: DivProps) => (
  <StyledModalContainer {...props}>{children}</StyledModalContainer>
);

export const ModalContentContainer = ({ children, ...props }: DivProps) => (
  <StyledModalContentContainer {...props}>
    {children}
  </StyledModalContentContainer>
);

export const ModalButtonContainer = ({ children, ...props }: DivProps) => (
  <StyledModalButtonContainer {...props}>{children}</StyledModalButtonContainer>
);
